import axios from "axios";
export const baseURL =
  process.env.REACT_APP_ADMIN_API || "https://api-admin.heimdallrwa.com";
/* export const baseURL = "http://localhost:3410"; */

export const adminAPI = async (method, url, options) => {
  if (!options) options = {};
  let urlencodedOptions = new URLSearchParams(
    Object.entries(options)
  ).toString();
  
  axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem("token");
    config.headers.Authorization = token;

    return config;
  });
  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      // Do something with response data
      if (response?.data.message === "Invalid Token") {
        window.location = "/";
        localStorage.setItem("token", "");
        localStorage.setItem("accountId", "");
        localStorage.setItem("applicationId", "");
      }
      return response;
    },
    function (error) {
      // Do something with response error
      return Promise.reject(error);
    }
  );

  const { data } = await axios({
    baseURL,
    url,
    method,
    data: urlencodedOptions,
    headers: {
      Accept: "*/*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return data;
};
